import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NavigationService } from 'src/app/services/navigation.service';
import { PowerBiService } from '../services/powerbi.service';
import { PowerBiReport } from '../models/powerbi-embed.model';
import { POWER_BI_REPORT_LABEL } from '../powerbi.constants';

@Component({
  selector: 'app-powerbi-dashboard',
  templateUrl: './powerbi-dashboard.component.html',
  styleUrls: ['./powerbi-dashboard.component.scss'],
})
export class PowerBiDashboardComponent implements OnInit {
  @Input() moduleName = '';

  reports: PowerBiReport[] = [];
  loading = true;
  errorMessage: string | null = null;

  readonly gridCells = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  readonly barHeights = [40, 65, 30, 80, 55, 70];
  readonly statusDots = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

  private clientKey: string | null = null;
  private moduleKey: string | null = null;

  constructor(
    private readonly powerBiService: PowerBiService,
    private readonly navigationService: NavigationService,
    private readonly route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      const decrypted = this.navigationService.decryptData(params);
      this.clientKey = decrypted['cl_key'];
      this.moduleKey = decrypted['md_key'];
    });
    this.loadReports();
  }

  openReport(reportId: string): void {
    const query: Record<string, string> = {};
    if (this.clientKey) {
      query['cl_key'] = this.clientKey;
    }
    if (this.moduleKey) {
      query['md_key'] = this.moduleKey;
    }
    this.navigationService.routerNavigate(
      `direct/${this.moduleName}/report/${reportId}`,
      query
    );
  }

  retry(): void {
    this.errorMessage = null;
    this.loading = true;
    this.loadReports();
  }

  previewVariant(index: number): number {
    return index % 4;
  }

  private loadReports(): void {
    this.powerBiService.getReports().subscribe({
      next: (reports) => {
        this.reports = reports;
        this.loading = false;

        if (reports.length === 0) {
          this.errorMessage = 'No Power BI reports found in the workspace.';
        }
      },
      error: (error) => {
        this.loading = false;
        this.errorMessage =
          error?.error?.message ??
          error?.message ??
          'Failed to load Power BI reports from the API.';
      },
    });
  }
}
